import { disableZoomOnInputFocus, vh } from "./functions";
vh();
// disableZoomOnInputFocus();
import "./splitText.js";

// import "./grid.js"
